import { render, staticRenderFns } from "./GlobalDiscountPricingShow.vue?vue&type=template&id=6e6134b8&"
import script from "./GlobalDiscountPricingShow.vue?vue&type=script&lang=js&"
export * from "./GlobalDiscountPricingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports